var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnviar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "enviar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Ficha_1",
    transform: "translate(-1202.000000, -6380.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(1130.000000, 6372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "enviar",
    transform: "translate(88.000000, 24.000000) rotate(-315.000000) translate(-88.000000, -24.000000) translate(78.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,20 C4.47715235,20 0,15.5228477 0,10 C0,4.47715235 4.47715235,0 10,0 C15.5228477,0 20,4.47715235 20,10 C20,15.5228477 15.5228477,20 10,20 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 13.5,
    x2: 10,
    y2: 7.5,
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,9.5 L10,6.5 L13,9.5",
    id: "Vector",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnviar);
export default __webpack_public_path__ + "static/media/enviar.654d211074636b52967c07636d73a058.svg";
export { ForwardRef as ReactComponent };